import React, { useEffect, useState } from "react";
import { BetaForm as useBetaForm } from "@reusejs/react";
import CustomModalLayout from "../../../web/Auth/CustomModalLayout";
import { Button } from "../../../../shadcn/components/ui/button";
import BidderOTPInputModal from "./BidderOTPInputModal";
import { OTPInputComponent } from "../../../web/Auth/OTPInputComponent";
import { useDispatch } from "react-redux";
import { addMobileNumber, getUser, requestMobileVerification } from "services";
import {
  alertUserOnMobileUpdate,
  getBidderOnboardingOfUser,
  requestVerifyAttribute,
  updateBidderOnboardingDataAfterKYC,
  verifyMobileNumber,
} from "services/bidder";
import {
  setBidderOnboarding,
  setBidderUser,
  setOnboarding,
  setUser,
} from "store";
interface BidderInputMobileNumberFormModelProps {
  mobileChangeState: any;
  setMobileChangeState: any;
  currentMobileNumber: any;
}

export default function BidderInputMobileNumberFormModel({
  mobileChangeState,
  setMobileChangeState,
  currentMobileNumber,
}: BidderInputMobileNumberFormModelProps) {
  const [inputModelOpen, setInputModalOpen] = useState(false);
  const form = useBetaForm({
    mobile_number: "",
    type: "mobile_number",
  });
  const mobileNumberRegEx: RegExp = /^[0-9]{10}$/;

  const form_constraints = {
    mobile_number: {
      presence: {
        allowEmpty: false,
      },
      format: {
        pattern: mobileNumberRegEx,
        message: "^Mobile number is not valid.",
      },
      exclusion: {
        within: [currentMobileNumber],
        message: "^Mobile number should be different from the current number.",
      },
      length: {
        maximum: 10,
        message: "^Mobile number is too long (maximum is 10 characters)",
      },
    },
  };
  useEffect(() => {
    form.setValidationRules(form_constraints);
  }, [currentMobileNumber, inputModelOpen]);

  const handleSubmit = async () => {
    try {
      console.log("form.validate()", form.validate());
      if (form.validate()) {
        try {
          let payload = {
            type: "mobile_number",
            value: form.getField("mobile_number"),
          };
          await addMobileNumber(payload);
          setInputModalOpen(true);
        } catch (error: any) {
          console.log("error: ", error);
          const errorMessage: any = error?.response?.data?.errors?.value;
          console.log("errorMessage: ", errorMessage);
          if (errorMessage[0] === "Value should be unique") {
            error.response.data.errors.value[0] =
              "This mobile number is already linked to another account";
          }
          form.pushError({ mobile_number: error.response.data.errors.value });
        }

        // await registerWithMobile(form).then((res: any) => {
        //   if (res.message === "Already Registered") {
        //     dispatch(setGuestUser({ guestUser: form.value }));
        //     setAction("verifyRegistration");
        //     setInputModalOpen(true);
        //     setRegisterModal(false);
        //   } else {
        //     dispatch(setGuestUser({ guestUser: form.value }));
        //     setAction("verifyRegistration");
        //     setInputModalOpen(true);
        //     setRegisterModal(false);
        //   }
        // });
      }
    } catch (error) {
      console.log("check here error", error);
    }
  };

  return (
    <CustomModalLayout
      open={mobileChangeState?.isConfirmingChange}
      childrenClassName="pb-6 px-8 overflow-y-scroll"
      className="pt-8 lg:pb-[30px] mx-4 overflow-y-scroll max-h-[calc(100%-10px)]"
      onClose={() =>
        setMobileChangeState({
          isConfirmingOpen: false,
          isConfirmingChange: false,
        })
      }
    >
      <div>
        <p
          className={`font-openSans font-semibold text-center text-[24px] leading-8 text-black mb-4`}
        >
          Update Mobile Number
        </p>
        <p className="font-openSans font-normal text-web-body-lg leading-[22px] text-brand-bgBlack mb-8">
          Please enter your details
        </p>

        <div className="space-y-2">
          <label className="font-openSans font-semibold text-web-body-sm leading-4 text-brand-bgBlack">
            Mobile Number
          </label>
          <input
            type="tel"
            placeholder="+91"
            value={form.getField("mobile_number")}
            onChange={(e) => form.setField("mobile_number", e.target.value)}
            className="bg-[#F8F8F8] border-none h-10 outline-none p-2 focus:ring-brand-orange w-full font-openSans font-semibold text-web-body-sm leading-4 text-brand-textBlack"
          />
          {form.errors.get("mobile_number") ? (
            <p className="mt-2 text-sm text-red-500">
              {form.errors.get("mobile_number")[0]}
            </p>
          ) : null}
        </div>
        <Button className="mt-12 w-full" onClick={() => handleSubmit()}>
          Next
        </Button>
        {/* <BidderOTPInputModal
          isEmail={false}
          userIdentity={form.getField("mobile_number")}
          inputModelOpen={inputModelOpen}
          setInputModalOpen={setInputModalOpen}
        /> */}
        <OTPInputModalForMobileUpdate
          userIdentity={form.getField("mobile_number")}
          inputModelOpen={inputModelOpen}
          setInputModalOpen={setInputModalOpen}
          setMobileChangeState={setMobileChangeState}
          prevForm={form}
        />
      </div>
    </CustomModalLayout>
  );
}

interface OTPInputModalForMobileUpdateProps {
  inputModelOpen: boolean;
  setInputModalOpen: any;
  userIdentity: any;
  setMobileChangeState: any;
  prevForm: any;
}
const OTPInputModalForMobileUpdate = ({
  inputModelOpen,
  setInputModalOpen,
  userIdentity,
  setMobileChangeState,
  prevForm,
}: OTPInputModalForMobileUpdateProps) => {
  console.log("userIdentity", userIdentity);
  const dispatch = useDispatch();
  const [timer, setTimer] = useState(60);
  const [loading, setLoading] = useState(false);
  const form = useBetaForm({
    user_identity: "",
    token: "",
  });
  const form_constraints = {
    user_identity: {
      presence: {
        allowEmpty: false,
      },
    },
    token: {
      presence: {
        allowEmpty: false,
        message: "^OTP can't be blank",
      },
    },
  };

  useEffect(() => {
    form.setField("user_identity", userIdentity);
    form.setValidationRules(form_constraints);
  }, [userIdentity]);

  useEffect(() => {
    let countdown: NodeJS.Timeout | null = null;

    if (timer > 0) {
      countdown = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    }

    return () => {
      if (countdown) clearInterval(countdown);
    };
  }, [timer]);

  const handleResendOTP = async () => {
    try {
      setTimer(60); // Reset timer back to 20 seconds
      const payload = {
        type: "mobile_number",
        value: "+91" + userIdentity,
      };

      await requestVerifyAttribute(payload);
      form.removeError("token");
      form.setField("token", "");
    } catch (error) {
      console.log("check here error", error);
    }
  };

  const handleVerification = async () => {
    try {
      setLoading(true);
      if (form.validate()) {
        await verifyMobileNumber({
          value: form.getField("user_identity"),
          otp: form.getField("token"),
        });
        const user: any = await getUser();
        dispatch(setUser(user));
        dispatch(setBidderUser(user));
        //update bidder
        const onboarding: any = await getBidderOnboardingOfUser(user?.uuid);

        dispatch(setBidderOnboarding(onboarding));
        dispatch(setOnboarding(onboarding));
        if (onboarding?.mobile && onboarding.uuid) {
          await updateBidderOnboardingDataAfterKYC({
            uuid: onboarding.uuid,
            payload: {
              ...onboarding,
              mobile: userIdentity,
            },
          });
        }
        try {
          const alertPayload = {
            user_name: onboarding?.name || user?.profile?.name || "User",
            mobile_number: `+91${userIdentity}`,
            email: onboarding?.email,
          };
          await alertUserOnMobileUpdate(alertPayload);
        } catch (error) {
          console.log("error:alertUserOnMobileUpdate", error);
        }
        prevForm.setField("mobile_number", "");
        setMobileChangeState({
          isConfirmingOpen: false,
          isConfirmingChange: false,
        });
        setInputModalOpen(false);
      }
    } catch (error: any) {
      setLoading(false);
      console.log("check here error-------->>>", error);
      if (error?.response?.status >= 500) {
        form.setErrors({
          token: ["Something went wrong, please try again later."],
        });
        return;
      }
      form.setErrors({
        token: ["The OTP you entered is incorrect.Try again."],
      });
    }
  };
  return (
    <CustomModalLayout
      open={inputModelOpen}
      className={`pt-8 pb-[30px] min-h-[583px] `}
      childrenClassName="pl-4 pr-6"
      onClose={() => setInputModalOpen(false)}
    >
      <div className="h-full flex flex-col flex-grow">
        <div>
          <p
            className={`font-openSans font-semibold text-center text-[24px] leading-8 text-black `}
          >
            {"Verify your number"}
          </p>
          <div className="flex space-x-2 mt-[45px]">
            <p className="font-openSans font-normal text-web-body-lg leading-[22px] text-brand-textGrey">
              OTP sent to{" "}
              <strong className="font-semibold">
                {form.getField("user_identity")}
              </strong>
            </p>
            <button
              className="underline"
              onClick={() => {
                setInputModalOpen(false);
              }}
            >
              Edit
            </button>
          </div>
          <p className="font-openSans font-semibold text-web-body-sm leading-4 text-brand-bgBlack mt-8">
            Verify OTP
          </p>
          <div className="w-full flex justify-center mt-2">
            <OTPInputComponent
              otpEntered={form.getField("token")}
              setOtpEntered={(v) => form.setField("token", v)}
            />
          </div>
          {form.errors.get("token") ? (
            <p className="mt-2 text-sm text-red-500">
              {form.errors.get("token")[0]}
            </p>
          ) : null}
          <div className="mt-7 flex items-center font-openSans font-normal text-web-body-sm leading-[18px] text-[#717272] space-x-2">
            <p className="">Didn’t get OTP? </p>
            {timer > 0 ? (
              <p>Resend OTP in {timer} sec</p>
            ) : (
              <button
                className="underline"
                onClick={handleResendOTP}
                // disabled={isButtonDisabled}
              >
                Resend OTP
              </button>
            )}
          </div>
        </div>
        <Button
          className="w-full mt-auto mb-[60px]"
          disabled={loading}
          onClick={() => handleVerification()}
        >
          Verify
        </Button>
      </div>
    </CustomModalLayout>
  );
};
